if (!customElements.get('collection-header-slider')) {
  customElements.define(
    'collection-header-slider',
    class CollectionHeaderSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.collection-header__viewport');
        this.track = this.querySelector('.collection-header__track');
        this.prevBtn = this.querySelector('.collection-header__btn--prev');
        this.nextBtn = this.querySelector('.collection-header__btn--next');
        this.slidesPerView = parseInt(this.dataset.slidesPerView) || 7;
        this.currentIndex = 0;

        if (!this.track || !this.prevBtn || !this.nextBtn) return;

        this.items = Array.from(this.track.children);
        if (this.items.length === 0) return;

        this.resizeObserver = new ResizeObserver(() => this.onResize());
        this.resizeObserver.observe(this.viewport);

        this.prevBtn.addEventListener('click', () => this.slide(-1));
        this.nextBtn.addEventListener('click', () => this.slide(1));

        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      isMobile() {
        return window.innerWidth <= 749;
      }

      onResize() {
        this.currentIndex = 0;
        this.update();
      }

      getItemWidth() {
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        return (this.viewport.offsetWidth - gap * (this.slidesPerView - 1)) / this.slidesPerView;
      }

      setItemWidths() {
        const width = this.getItemWidth();
        this.items.forEach((item) => {
          item.style.width = width + 'px';
        });
      }

      slide(direction) {
        const maxIndex = Math.max(0, this.items.length - this.slidesPerView);
        this.currentIndex = Math.max(0, Math.min(this.currentIndex + direction, maxIndex));
        this.update();
      }

      update() {
        if (this.isMobile()) {
          this.track.style.transform = '';
          this.items.forEach((item) => (item.style.width = ''));
          this.prevBtn.disabled = true;
          this.nextBtn.disabled = true;
          return;
        }

        this.setItemWidths();

        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const itemWidth = this.getItemWidth();
        const offset = this.currentIndex * (itemWidth + gap);
        this.track.style.transform = `translateX(-${offset}px)`;
        this.track.style.transition = 'transform 0.4s ease';

        const maxIndex = Math.max(0, this.items.length - this.slidesPerView);
        this.prevBtn.disabled = this.currentIndex === 0;
        this.nextBtn.disabled = this.currentIndex >= maxIndex;
      }
    }
  );
}
